import { memo } from 'react';
import Stack from '@mui/material/Stack';
import NavList from './nav_list';

function NavSectionMini({ data, sx, currentNav, onItemClick }) {
  const renderContent = data.map((list, index) => (
    <NavList
      key={index}
      data={list}
      isSelected={currentNav}
      onItemClick={onItemClick}
    />
  ));

  return <Stack sx={sx}>{renderContent}</Stack>;
}

export default memo(NavSectionMini);
